import bgLandSrc from "../../assets/images/myBear/bg_land.png";
import bearSrc01 from "../../assets/images/myBear/bear01.png";
import bearSrc02 from "../../assets/images/myBear/bear02.png";
import bearSrc03 from "../../assets/images/myBear/bear03.png";
import bearSrc04 from "../../assets/images/myBear/bear04.png";
import dialogSrc from "../../assets/images/myBear/dialog.png";
import gunSrc from "../../assets/images/myBear/gun.png";
import downloadBtnSrc from "../../assets/images/myBear/download_btn.png";
import downloadBoxSrc from "../../assets/images/myBear/download_box.png";
import downloadHover01Src from "../../assets/images/myBear/download_hover_01.png";
import downloadHover02Src from "../../assets/images/myBear/download_hover_02.png";
import download01Src from "../../assets/images/myBear/download_01.png";
import download02Src from "../../assets/images/myBear/download_02.png";
import downloadHoverEn01Src from "../../assets/images/myBear/download_en_hover_01.png";
import downloadHoverEn02Src from "../../assets/images/myBear/download_en_hover_02.png";
import downloadEn01Src from "../../assets/images/myBear/download_en_01.png";
import downloadEn02Src from "../../assets/images/myBear/download_en_02.png";
import downloadHoverJp01Src from "../../assets/images/myBear/download_jp_hover_01.png";
import downloadHoverJp02Src from "../../assets/images/myBear/download_jp_hover_02.png";
import downloadJp01Src from "../../assets/images/myBear/download_jp_01.png";
import downloadJp02Src from "../../assets/images/myBear/download_jp_02.png";
import downloadHoverCn01Src from "../../assets/images/myBear/download_cn_hover_01.png";
import downloadHoverCn02Src from "../../assets/images/myBear/download_cn_hover_02.png";
import downloadCn01Src from "../../assets/images/myBear/download_cn_01.png";
import downloadCn02Src from "../../assets/images/myBear/download_cn_02.png";
import qaBtnSrc from "../../assets/images/myBear/qa_btn.png";
import qaRemindLineSrc from "../../assets/images/myBear/qa_remind_line.png";
import progressTitleSrc from "../../assets/images/myBear/progress_title.png";
import progressTitleZhSrc from "../../assets/images/myBear/progress_title_zh.png";
import progressTitleCnSrc from "../../assets/images/myBear/progress_title_cn.png";
import progressTitleJpSrc from "../../assets/images/myBear/progress_title_jp.png";
import progressTitleEnSrc from "../../assets/images/myBear/progress_title_en.png";
import planetSrc01 from "../../assets/images/myBear/planet01.png";
import planetSrc02 from "../../assets/images/myBear/planet02.png";
import planetSrc03 from "../../assets/images/myBear/planet03.png";
import categoryBtn01 from "../../assets/images/myBear/category_btn_01.png";
import categoryBtn02 from "../../assets/images/myBear/category_btn_02.png";
import categoryBtn03 from "../../assets/images/myBear/category_btn_03.png";
import categoryBg01 from "../../assets/images/myBear/category_bg_01.png";
import categoryBg02 from "../../assets/images/myBear/category_bg_02.png";
import categoryBg03 from "../../assets/images/myBear/category_bg_03.png";
import icon01 from "../../assets/images/myBear/icon01.png";
import icon02 from "../../assets/images/myBear/icon02.png";
import icon03 from "../../assets/images/myBear/icon03.png";
import icon04 from "../../assets/images/myBear/icon04.png";
import equipmentLock from "../../assets/images/myBear/equipment_lock.png";
import canvasBg00 from "../../assets/images/equipment/canvas_bg00.jpg";
import canvasBgSmall00 from "../../assets/images/equipment/canvas_bg_small00.jpg";
import canvasLogo from "../../assets/images/myBear/tsmc-DEI.png";
import canvasName from "../../assets/images/myBear/canvas_name.png";
import star01 from "../../assets/images/myBear/star01.png";
import star02 from "../../assets/images/myBear/star02.png";
import star03 from "../../assets/images/myBear/star03.png";
import star04 from "../../assets/images/myBear/star04.png";
import star05 from "../../assets/images/myBear/star05.png";
import scrollDown from "../../assets/images/myBear/scroll_down.png";
import introBtn from "../../assets/images/myBear/intro_btn.png";
import tsmcLogo from "../../assets/images/myBear/tsmc_logo.png";

const images = {
  bgLandSrc,
  bearSrc01,
  bearSrc02,
  bearSrc03,
  bearSrc04,
  dialogSrc,
  gunSrc,
  downloadBtnSrc,
  downloadBoxSrc,
  downloadHover01Src,
  downloadHover02Src,
  downloadEn01Src,
  downloadEn02Src,
  downloadHoverEn01Src,
  downloadHoverEn02Src,
  downloadJp01Src,
  downloadJp02Src,
  downloadHoverJp01Src,
  downloadHoverJp02Src,
  downloadCn01Src,
  downloadCn02Src,
  downloadHoverCn01Src,
  downloadHoverCn02Src,
  download01Src,
  download02Src,
  qaBtnSrc,
  qaRemindLineSrc,
  progressTitleSrc,
  progressTitleZhSrc,
  progressTitleCnSrc,
  progressTitleJpSrc,
  progressTitleEnSrc,
  planetSrc01,
  planetSrc02,
  planetSrc03,
  categoryBtn01,
  categoryBtn02,
  categoryBtn03,
  categoryBg01,
  categoryBg02,
  categoryBg03,
  icon01,
  icon02,
  icon03,
  icon04,
  equipmentLock,
  canvasBg00,
  canvasBgSmall00,
  canvasLogo,
  canvasName,
  star01,
  star02,
  star03,
  star04,
  star05,
  scrollDown,
  introBtn,
  tsmcLogo,
};

export default images;
